import { IColumnData } from '../data/model/model';
import { EEntityType } from '../types';
import { EEntityStatus } from '../types/entity';
import { ColumnModel } from './2d/columnModel';
import BaseEntity from './BaseEntity';

export class ColumnEntity extends BaseEntity<EEntityType.Column> {
  protected override _model2d: ColumnModel;
  private _columnData: IColumnData;
  private _status: EEntityStatus;

  constructor(data: IColumnData) {
    super({ type: EEntityType.Column, id: data.id });

    this._columnData = data;
    this._status = EEntityStatus.normal;
    this._model2d = new ColumnModel({ ...data, status: this._status });
  }

  get columnData() {
    return this._columnData;
  }

  get status() {
    return this._status;
  }

  set status(status: EEntityStatus) {
    this._status = status;
    this.update(this._columnData);
  }

  override set selected(value: boolean) {
    this._selected = value;
    this.update(this._columnData);
  }
  override get selected() {
    return this._selected;
  }

  setVisible(visible: boolean) {
    this._model2d.setVisible(visible);
  }

  getVisible() {
    return this._model2d.getVisible();
  }

  override update(columnData: IColumnData) {
    this._columnData = columnData;

    this._model2d.update({ ...columnData, selected: this._selected, status: this._status });
  }

  clear() {
    this._model2d.clear();
  }
}
